<template>
  <b-modal header-close-content="" id="versioning-comment-modal" :title="$t('CatalogVersioning')" @ok="confirmHandler">
    <b-form-group data-cy="catalog-versioning-modal-fg">
      <label>
        <strong>{{ $t("remarks") }} </strong>
      </label>
      <b-input v-model="remarks" data-cy="catalog-versioning-input" />
    </b-form-group>
    <template #modal-footer="{ ok, cancel }">
      <b-btn @click="ok" variant="primary" data-cy="catalog-versioning-save-btn">{{ $t("Save") }}</b-btn>
      <b-btn @click="cancel">{{ $t("Cancel") }}</b-btn>
    </template>
  </b-modal>
</template>

<script>
import catalogApi from "../../services/catalogs";

export default {
  props: ["selectedCatalog", "language"],
  data() {
    return {
      remarks: null
    };
  },
  computed: {
    currentCatalog() {
      return this.selectedCatalog[this.language];
    }
  },
  methods: {
    confirmHandler(event) {
      catalogApi
        .createSnapShot(this.currentCatalog.catalogId, this.language, this.remarks)
        .then(() => {
          this.$emit("ok", event);
        })
        .catch((error) => {
          console.error("Snapshot could not be Created", error);
          this.$emit("error", error);
        })
        .finally(() => {
          this.remarks = null;
        });
    }
  }
};
</script>
